import { render, staticRenderFns } from "./DistributionSortingDetails.vue?vue&type=template&id=6f131a7d&scoped=true&"
import script from "./DistributionSortingDetails.vue?vue&type=script&lang=ts&"
export * from "./DistributionSortingDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f131a7d",
  null
  
)

export default component.exports